import axiosInstance from './../interceptor/interceptor';

export const budgetService = {
  getBudgetList,
  getBudgetById,
  getMonthlyBudget,
  //   updateCourse,
};

const config = {
  // headers: {
  //   "Content-Type": "application/json",
  // },
};
// , "Authorization": `bearer ${localStorage.getItem('ed_token')}`

function getBudgetList(obj) {
  return axiosInstance
    .get(
      `api?method=get_budget_list&user_id=${encodeURIComponent(obj.user_id)}&status=${obj.status}`
    );
}

// Get Montly Budget
function getMonthlyBudget(obj) {
  obj.method = "get_monthly_budget";
  let queryParam = "";
  obj.user_id = encodeURIComponent(obj.user_id);
  for (var key in obj)
    queryParam =
      queryParam == ""
        ? queryParam + `${key}=${obj[key]}`
        : queryParam + `&${key}=${obj[key]}`;
  
  return axiosInstance
    .get(`api?${queryParam}`, config);
}
// Get course by id
function getBudgetById(user_id, budget_id) {
  return axiosInstance
    .get(`api?method=get_budget_by_id&user_id=${encodeURIComponent(user_id)}&budget_id=${budget_id}`,
      config
    )
    .then((budget) => {
      if (budget.data.status === 201) {
        return budget.data.result;
      } else {
        return budget.data;
      }
    });
}
/*
// Delete Transaction
function addCourse(data) {
  return axios
    .delete(`${react_app_base_url}courseapi/create`, data)
    .then((resp) => {
      if (resp.data.code === 201) {
        return resp.data.data;
      } else {
        return resp.data;
      }
    });
}

// Update Course
function updateCourse(data) {
  return axios
    .post(`${appConstants.BASE_URL}courseapi/update`, data)
    .then((resp) => {
      if (resp.data.code === 201) {
        return resp.data.data;
      } else {
        return resp.data;
      }
    });
}
*/
